module.exports = __webpack_public_path__ + "static/media/arrow-down.1aa9da37.svg";